<template>
  <v-list-item class="px-0 primary">
    <v-row>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">日付</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">お引出金額</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">お預入れ金額</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">残高</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">支払先/顧客名</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">勘定科目名</v-col>
    </v-row>
  </v-list-item>
</template>

<script>
export default {
  name: 'authorBbookPreviewRakutenHeader',
}
</script>